


// Simple, stable Zustand store for chat state
import { create } from 'zustand';
import { Conversation, Message, ChatState } from 'utils/chatTypes';
import { markConversationAsRead as markConversationAsReadInFirebase } from './chatService';

// Create store with stable functions to prevent infinite re-renders
export const useChatStore = create<ChatState & {
  // Actions
  setConversations: (conversations: Conversation[]) => void;
  setSelectedConversation: (conversation: Conversation | null) => void;
  setMessages: (conversationId: string, messages: Message[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  markConversationAsRead: (conversationId: string, userId: string) => void;
  reset: () => void;
}>((set, get) => ({
  // Initial state
  conversations: [],
  selectedConversation: null,
  messages: {},
  isLoading: false,
  error: null,

  // Actions with stable references
  setConversations: (conversations) => set({ conversations }),
  
  setSelectedConversation: (conversation) => set({ selectedConversation: conversation }),
  
  setMessages: (conversationId, messages) => set((state) => ({
    messages: {
      ...state.messages,
      [conversationId]: messages
    }
  })),
  
  setLoading: (isLoading) => set({ isLoading }),
  
  setError: (error) => set({ error }),
  
  markConversationAsRead: (conversationId, userId) => {
    // Update local state immediately for optimistic UI
    set((state) => ({
      conversations: state.conversations.map(conv => 
        conv.id === conversationId 
          ? {
              ...conv,
              lastReadBy: {
                ...conv.lastReadBy,
                [userId]: new Date()
              },
              unreadCount: {
                ...conv.unreadCount,
                [userId]: 0
              }
            }
          : conv
      )
    }));
    
    // Persist to Firebase
    markConversationAsReadInFirebase(conversationId, userId).catch(error => {
      console.error('Failed to mark conversation as read in Firebase:', error);
    });
  },
  
  reset: () => set({
    conversations: [],
    selectedConversation: null,
    messages: {},
    isLoading: false,
    error: null
  })
}));



